import { render, staticRenderFns } from "./overdue-pie.vue?vue&type=template&id=387cb6c4&scoped=true&"
import script from "./overdue-pie.vue?vue&type=script&lang=js&"
export * from "./overdue-pie.vue?vue&type=script&lang=js&"
import style0 from "./overdue-pie.vue?vue&type=style&index=0&id=387cb6c4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "387cb6c4",
  null
  
)

export default component.exports